export default "__VITE_ASSET__AlEi0yVu__"